/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * OSI.Core
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiResponse,
  ApiResponseDbOsiServiceOSICoreTypes,
  ApiResponseInt32SystemPrivateCoreLib,
  ApiResponseList1OSICoreModelsResponsesAbonentOnServiceResponsePrivateCoreLib,
  ApiResponseList1OSICoreModelsResponsesOsiServiceResponsePrivateCoreLib,
  GetApiOsiServicesNeedsMonthlyConfirmationParams,
  PutApiOsiServicesIdAbonentsParams,
  PutApiOsiServicesIdSetStateParams,
  RequestsAbonentOnServiceRequest,
  RequestsCreateAccuralsForServicesRequest,
  RequestsOsiServiceRequest
} from '../models';

import { axiosForReactQueryInstance } from '../../reactQuery';
import type { ErrorType, BodyType } from '../../reactQuery';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Получить данные услуги ОСИ
 */
export const getApiOsiServicesId = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseDbOsiServiceOSICoreTypes>(
    { url: `/api/OsiServices/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiServicesIdQueryKey = (id: number) => {
  return [`/api/OsiServices/${id}`] as const;
};

export const getGetApiOsiServicesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiServicesId>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiServicesId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiServicesIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiServicesId>>> = ({ signal }) =>
    getApiOsiServicesId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiServicesId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiServicesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOsiServicesId>>>;
export type GetApiOsiServicesIdQueryError = ErrorType<unknown>;

export function useGetApiOsiServicesId<
  TData = Awaited<ReturnType<typeof getApiOsiServicesId>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiServicesId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiServicesId>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiServicesId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiServicesId<
  TData = Awaited<ReturnType<typeof getApiOsiServicesId>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiServicesId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiServicesId>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiServicesId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiServicesId<
  TData = Awaited<ReturnType<typeof getApiOsiServicesId>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiServicesId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить данные услуги ОСИ
 */

export function useGetApiOsiServicesId<
  TData = Awaited<ReturnType<typeof getApiOsiServicesId>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiServicesId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiServicesIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Изменить услугу ОСИ
 */
export const putApiOsiServicesId = (
  id: number,
  requestsOsiServiceRequest: BodyType<RequestsOsiServiceRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    {
      url: `/api/OsiServices/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: requestsOsiServiceRequest
    },
    options
  );
};

export const getPutApiOsiServicesIdMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiOsiServicesId>>,
    TError,
    { id: number; data: BodyType<RequestsOsiServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiOsiServicesId>>,
  TError,
  { id: number; data: BodyType<RequestsOsiServiceRequest> },
  TContext
> => {
  const mutationKey = ['putApiOsiServicesId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiOsiServicesId>>,
    { id: number; data: BodyType<RequestsOsiServiceRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiOsiServicesId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiOsiServicesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiOsiServicesId>>>;
export type PutApiOsiServicesIdMutationBody = BodyType<RequestsOsiServiceRequest>;
export type PutApiOsiServicesIdMutationError = ErrorType<unknown>;

/**
 * @summary Изменить услугу ОСИ
 */
export const usePutApiOsiServicesId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiOsiServicesId>>,
      TError,
      { id: number; data: BodyType<RequestsOsiServiceRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiOsiServicesId>>,
  TError,
  { id: number; data: BodyType<RequestsOsiServiceRequest> },
  TContext
> => {
  const mutationOptions = getPutApiOsiServicesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Добавить услугу ОСИ
 */
export const postApiOsiServices = (
  requestsOsiServiceRequest: BodyType<RequestsOsiServiceRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseDbOsiServiceOSICoreTypes>(
    {
      url: `/api/OsiServices`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsOsiServiceRequest,
      signal
    },
    options
  );
};

export const getPostApiOsiServicesMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiOsiServices>>,
    TError,
    { data: BodyType<RequestsOsiServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiOsiServices>>,
  TError,
  { data: BodyType<RequestsOsiServiceRequest> },
  TContext
> => {
  const mutationKey = ['postApiOsiServices'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiOsiServices>>,
    { data: BodyType<RequestsOsiServiceRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiOsiServices(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiOsiServicesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiOsiServices>>>;
export type PostApiOsiServicesMutationBody = BodyType<RequestsOsiServiceRequest>;
export type PostApiOsiServicesMutationError = ErrorType<unknown>;

/**
 * @summary Добавить услугу ОСИ
 */
export const usePostApiOsiServices = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiOsiServices>>,
      TError,
      { data: BodyType<RequestsOsiServiceRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiOsiServices>>,
  TError,
  { data: BodyType<RequestsOsiServiceRequest> },
  TContext
> => {
  const mutationOptions = getPostApiOsiServicesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Получение списка абонентов на услуге
 */
export const getApiOsiServicesIdAbonents = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseList1OSICoreModelsResponsesAbonentOnServiceResponsePrivateCoreLib>(
    { url: `/api/OsiServices/${id}/abonents`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiServicesIdAbonentsQueryKey = (id: number) => {
  return [`/api/OsiServices/${id}/abonents`] as const;
};

export const getGetApiOsiServicesIdAbonentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiServicesIdAbonents>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiServicesIdAbonents>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiServicesIdAbonentsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiServicesIdAbonents>>> = ({ signal }) =>
    getApiOsiServicesIdAbonents(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiServicesIdAbonents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiServicesIdAbonentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiOsiServicesIdAbonents>>
>;
export type GetApiOsiServicesIdAbonentsQueryError = ErrorType<unknown>;

export function useGetApiOsiServicesIdAbonents<
  TData = Awaited<ReturnType<typeof getApiOsiServicesIdAbonents>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiServicesIdAbonents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiServicesIdAbonents>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiServicesIdAbonents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiServicesIdAbonents<
  TData = Awaited<ReturnType<typeof getApiOsiServicesIdAbonents>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiServicesIdAbonents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiServicesIdAbonents>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiServicesIdAbonents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiServicesIdAbonents<
  TData = Awaited<ReturnType<typeof getApiOsiServicesIdAbonents>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiServicesIdAbonents>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получение списка абонентов на услуге
 */

export function useGetApiOsiServicesIdAbonents<
  TData = Awaited<ReturnType<typeof getApiOsiServicesIdAbonents>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiServicesIdAbonents>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiServicesIdAbonentsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Добавление и/или удаление списка абонентов на услуге
 */
export const putApiOsiServicesIdAbonents = (
  id: number,
  requestsAbonentOnServiceRequest: BodyType<RequestsAbonentOnServiceRequest[]>,
  params?: PutApiOsiServicesIdAbonentsParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    {
      url: `/api/OsiServices/${id}/abonents`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: requestsAbonentOnServiceRequest,
      params
    },
    options
  );
};

export const getPutApiOsiServicesIdAbonentsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiOsiServicesIdAbonents>>,
    TError,
    { id: number; data: BodyType<RequestsAbonentOnServiceRequest[]>; params?: PutApiOsiServicesIdAbonentsParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiOsiServicesIdAbonents>>,
  TError,
  { id: number; data: BodyType<RequestsAbonentOnServiceRequest[]>; params?: PutApiOsiServicesIdAbonentsParams },
  TContext
> => {
  const mutationKey = ['putApiOsiServicesIdAbonents'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiOsiServicesIdAbonents>>,
    { id: number; data: BodyType<RequestsAbonentOnServiceRequest[]>; params?: PutApiOsiServicesIdAbonentsParams }
  > = (props) => {
    const { id, data, params } = props ?? {};

    return putApiOsiServicesIdAbonents(id, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiOsiServicesIdAbonentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiOsiServicesIdAbonents>>
>;
export type PutApiOsiServicesIdAbonentsMutationBody = BodyType<RequestsAbonentOnServiceRequest[]>;
export type PutApiOsiServicesIdAbonentsMutationError = ErrorType<unknown>;

/**
 * @summary Добавление и/или удаление списка абонентов на услуге
 */
export const usePutApiOsiServicesIdAbonents = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiOsiServicesIdAbonents>>,
      TError,
      { id: number; data: BodyType<RequestsAbonentOnServiceRequest[]>; params?: PutApiOsiServicesIdAbonentsParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiOsiServicesIdAbonents>>,
  TError,
  { id: number; data: BodyType<RequestsAbonentOnServiceRequest[]>; params?: PutApiOsiServicesIdAbonentsParams },
  TContext
> => {
  const mutationOptions = getPutApiOsiServicesIdAbonentsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Отключение/включение услуги всем абонентам
 */
export const putApiOsiServicesIdSetState = (
  id: number,
  params?: PutApiOsiServicesIdSetStateParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    { url: `/api/OsiServices/${id}/set-state`, method: 'PUT', params },
    options
  );
};

export const getPutApiOsiServicesIdSetStateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiOsiServicesIdSetState>>,
    TError,
    { id: number; params?: PutApiOsiServicesIdSetStateParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiOsiServicesIdSetState>>,
  TError,
  { id: number; params?: PutApiOsiServicesIdSetStateParams },
  TContext
> => {
  const mutationKey = ['putApiOsiServicesIdSetState'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiOsiServicesIdSetState>>,
    { id: number; params?: PutApiOsiServicesIdSetStateParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return putApiOsiServicesIdSetState(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiOsiServicesIdSetStateMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiOsiServicesIdSetState>>
>;

export type PutApiOsiServicesIdSetStateMutationError = ErrorType<unknown>;

/**
 * @summary Отключение/включение услуги всем абонентам
 */
export const usePutApiOsiServicesIdSetState = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiOsiServicesIdSetState>>,
      TError,
      { id: number; params?: PutApiOsiServicesIdSetStateParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiOsiServicesIdSetState>>,
  TError,
  { id: number; params?: PutApiOsiServicesIdSetStateParams },
  TContext
> => {
  const mutationOptions = getPutApiOsiServicesIdSetStateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Услуги ОСИ с включённым RequiresMonthlyConfirmation, у которых нет суммы за текущий месяц.
Используется фронт-модалкой на /osi/accruals: при следующем cron-начислении такие услуги
будут пропущены фильтром в TransactionSvc, поэтому модалка предлагает пользователю ввести
сумму или снять флаг ежемесячного подтверждения.
 */
export const getApiOsiServicesNeedsMonthlyConfirmation = (
  params?: GetApiOsiServicesNeedsMonthlyConfirmationParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseList1OSICoreModelsResponsesOsiServiceResponsePrivateCoreLib>(
    { url: `/api/OsiServices/needs-monthly-confirmation`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiOsiServicesNeedsMonthlyConfirmationQueryKey = (
  params?: GetApiOsiServicesNeedsMonthlyConfirmationParams
) => {
  return [`/api/OsiServices/needs-monthly-confirmation`, ...(params ? [params] : [])] as const;
};

export const getGetApiOsiServicesNeedsMonthlyConfirmationQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiServicesNeedsMonthlyConfirmation>>,
  TError = ErrorType<unknown>
>(
  params?: GetApiOsiServicesNeedsMonthlyConfirmationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOsiServicesNeedsMonthlyConfirmation>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiServicesNeedsMonthlyConfirmationQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiServicesNeedsMonthlyConfirmation>>> = ({ signal }) =>
    getApiOsiServicesNeedsMonthlyConfirmation(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiServicesNeedsMonthlyConfirmation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiServicesNeedsMonthlyConfirmationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiOsiServicesNeedsMonthlyConfirmation>>
>;
export type GetApiOsiServicesNeedsMonthlyConfirmationQueryError = ErrorType<unknown>;

export function useGetApiOsiServicesNeedsMonthlyConfirmation<
  TData = Awaited<ReturnType<typeof getApiOsiServicesNeedsMonthlyConfirmation>>,
  TError = ErrorType<unknown>
>(
  params: undefined | GetApiOsiServicesNeedsMonthlyConfirmationParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOsiServicesNeedsMonthlyConfirmation>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiServicesNeedsMonthlyConfirmation>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiServicesNeedsMonthlyConfirmation>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiServicesNeedsMonthlyConfirmation<
  TData = Awaited<ReturnType<typeof getApiOsiServicesNeedsMonthlyConfirmation>>,
  TError = ErrorType<unknown>
>(
  params?: GetApiOsiServicesNeedsMonthlyConfirmationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOsiServicesNeedsMonthlyConfirmation>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiServicesNeedsMonthlyConfirmation>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiServicesNeedsMonthlyConfirmation>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiServicesNeedsMonthlyConfirmation<
  TData = Awaited<ReturnType<typeof getApiOsiServicesNeedsMonthlyConfirmation>>,
  TError = ErrorType<unknown>
>(
  params?: GetApiOsiServicesNeedsMonthlyConfirmationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOsiServicesNeedsMonthlyConfirmation>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Услуги ОСИ с включённым RequiresMonthlyConfirmation, у которых нет суммы за текущий месяц.
Используется фронт-модалкой на /osi/accruals: при следующем cron-начислении такие услуги
будут пропущены фильтром в TransactionSvc, поэтому модалка предлагает пользователю ввести
сумму или снять флаг ежемесячного подтверждения.
 */

export function useGetApiOsiServicesNeedsMonthlyConfirmation<
  TData = Awaited<ReturnType<typeof getApiOsiServicesNeedsMonthlyConfirmation>>,
  TError = ErrorType<unknown>
>(
  params?: GetApiOsiServicesNeedsMonthlyConfirmationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOsiServicesNeedsMonthlyConfirmation>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiServicesNeedsMonthlyConfirmationQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Создать начисления (без удаления существующих) по выбранным услугам в текущем плане ОСИ.
Используется фронт-кнопкой «Доначислить» в модалке /osi/accruals и
«Начислить по услуге» в форме редактирования услуги.
Идемпотентно: услуги, у которых уже есть ACC в текущем плане, пропускаются.
 */
export const postApiOsiServicesCreateAccuralsCurrentPlan = (
  requestsCreateAccuralsForServicesRequest: BodyType<RequestsCreateAccuralsForServicesRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseInt32SystemPrivateCoreLib>(
    {
      url: `/api/OsiServices/create-accurals-current-plan`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsCreateAccuralsForServicesRequest,
      signal
    },
    options
  );
};

export const getPostApiOsiServicesCreateAccuralsCurrentPlanMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiOsiServicesCreateAccuralsCurrentPlan>>,
    TError,
    { data: BodyType<RequestsCreateAccuralsForServicesRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiOsiServicesCreateAccuralsCurrentPlan>>,
  TError,
  { data: BodyType<RequestsCreateAccuralsForServicesRequest> },
  TContext
> => {
  const mutationKey = ['postApiOsiServicesCreateAccuralsCurrentPlan'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiOsiServicesCreateAccuralsCurrentPlan>>,
    { data: BodyType<RequestsCreateAccuralsForServicesRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiOsiServicesCreateAccuralsCurrentPlan(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiOsiServicesCreateAccuralsCurrentPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiOsiServicesCreateAccuralsCurrentPlan>>
>;
export type PostApiOsiServicesCreateAccuralsCurrentPlanMutationBody =
  BodyType<RequestsCreateAccuralsForServicesRequest>;
export type PostApiOsiServicesCreateAccuralsCurrentPlanMutationError = ErrorType<unknown>;

/**
 * @summary Создать начисления (без удаления существующих) по выбранным услугам в текущем плане ОСИ.
Используется фронт-кнопкой «Доначислить» в модалке /osi/accruals и
«Начислить по услуге» в форме редактирования услуги.
Идемпотентно: услуги, у которых уже есть ACC в текущем плане, пропускаются.
 */
export const usePostApiOsiServicesCreateAccuralsCurrentPlan = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiOsiServicesCreateAccuralsCurrentPlan>>,
      TError,
      { data: BodyType<RequestsCreateAccuralsForServicesRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiOsiServicesCreateAccuralsCurrentPlan>>,
  TError,
  { data: BodyType<RequestsCreateAccuralsForServicesRequest> },
  TContext
> => {
  const mutationOptions = getPostApiOsiServicesCreateAccuralsCurrentPlanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
